import React from 'react'
import success from '../assets/pay_success.png'

export const AppPaymentSuccess: React.FC = () => {


  const handleJump = () => {
    window.location.href = 'shenma://pay'
  }

  const styles = {
    pageContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      margin: 0,
      padding: '20px',
      boxSizing: 'border-box',
      background: '#ffffff',
      textAlign: 'center',
    },
    image: {
      width: '150px',
      height: '150px',
      objectFit: 'cover',
      marginBottom: '12px',
      display: 'block',
    },
    text: {
      fontSize: '16px',
      fontWeight: '600',
      color: '#333',
      margin: '0 0 12px 0',
      textAlign: 'center',
    },
    content: {
      fontSize: '14px',
      color: '#333',
      margin: '0 0 60px 0',
      textAlign: 'center',
    },
    button: {
      padding: '8px 40px',
      fontSize: '16px',
      fontWeight: 'bold',
      color: '#141F39',
      backgroundColor: '#FFC107',
      border: 'none',
      borderRadius: '10px',
      cursor: 'pointer',
      textTransform: 'none',
    },
  }

  return (
    <div style={styles.pageContainer}>
      <img
        src={success}
        alt=""
        style={styles.image}
      />
      <p style={styles.text}>Thank you!</p>
      <p style={styles.content}>Your payment successful.</p>
      <button style={styles.button} onClick={handleJump}>
        Back to SHENMA Mobile
      </button>
    </div>
  )
}

